import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Grid,
  Box,
  CircularProgress,
} from "@mui/material";
  import { useAlerta } from "utils/alertas";

const ActualizarGruposEstado = ({
  open,
  onClose,
  usuarioId,
  onActualizado
}) => {
    const [inscripciones, setInscripciones] = useState([]);
    const [inscripcionSeleccionada, setInscripcionSeleccionada] = useState("");
    const [inscripcion, setInscripcion] = useState(null);
    const [tipoPrograma, setTipoPrograma] = useState("");
    const [tipoCarrera, setTipoCarrera] = useState("");
    const [instituto, setInstituto] = useState("");
    const [duracion, setDuracion] = useState("");
    const [programasDisponibles, setProgramasDisponibles] = useState([]);
    const [semestres, setSemestres] = useState([]);
    const [gestiones, setGestiones] = useState([]);
    const [grupos, setGrupos] = useState([]);
    const [carreraId, setCarreraId] = useState("");
    const [capacitacionId, setCapacitacionId] = useState("");
    const [semestreId, setSemestreId] = useState("");
    const [gestionId, setGestionId] = useState("");
    const [grupo, setGrupo] = useState("");
    const [estado, setEstado] = useState("");
    const [loading, setLoading] = useState(false);
    const [loadingProgramas, setLoadingProgramas] = useState(false);
    const [loadingSemestres, setLoadingSemestres] = useState(false);
    const [loadingGrupos, setLoadingGrupos] = useState(false);
    const { mostrarAlerta } = useAlerta();

  const token = sessionStorage.getItem("access_token");
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    if (!open || !usuarioId) return;

    const cargarInscripciones = async () => {
      try {
        setLoading(true);

        const res = await axios.get(
          `${API_URL}/usuarios/${usuarioId}/inscripciones`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = res.data;


        setInscripciones(Array.isArray(data) ? data : []);

      } catch (error) {
        console.error(
          "Error cargando las inscripciones:",
          error
        );

        setInscripciones([]);
      } finally {
        setLoading(false);
      }
    };

    cargarInscripciones();

  }, [open, usuarioId]);
  const guardarInscripcion = async () => {
    if (!inscripcion) {
        return;
    }

    try {
        setLoading(true);

        const tipoOriginal =
        inscripcion.tipo_programa === "capacitacion"
            ? "capacitacion"
            : "carrera";

        const datos = {
        carrera_id:
            tipoOriginal === "carrera"
            ? carreraId
                ? Number(carreraId)
                : null
            : null,

        capacitacion_id:
            tipoOriginal === "capacitacion"
            ? capacitacionId
                ? Number(capacitacionId)
                : null
            : null,

        semestre_id: semestreId
            ? Number(semestreId)
            : null,

        gestion_id: gestionId
            ? Number(gestionId)
            : null,

        grupo_id: grupo
            ? Number(grupo)
            : null,

        estado: estado,

        convalidacion:
            tipoPrograma === "convalidacion",
        };

        const res = await axios.put(
        `${API_URL}/inscripciones/${tipoOriginal}/${inscripcion.id}/actualizar`,
        datos,
        {
            headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            },
        }
        );

        mostrarAlerta("Inscripción actualizada correctamente","success");

        if (onActualizado) {
            await onActualizado();
        }

        limpiarModal();
        onClose();

    } catch (error) {

        console.error(
        "ERROR ACTUALIZANDO INSCRIPCIÓN:",
        error
        );

        console.error(
        "RESPUESTA DEL SERVIDOR:",
        error.response?.data
        );

        alert(
        error.response?.data?.message ||
        "Error al actualizar la inscripción."
        );

    } finally {
        setLoading(false);
    }
    };

  useEffect(() => {
    if (!open) return;

    const fetchGestiones = async () => {
      try {
        const res = await fetch(
          `${API_URL}/gestiones`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );

        const data = await res.json();

        const lista = Array.isArray(data)
          ? data
          : data.data || [];

        setGestiones(lista);

      } catch (error) {
        console.error(
          "Error cargando gestiones:",
          error
        );

        setGestiones([]);
      }
    };

    fetchGestiones();

  }, [open]);

  const obtenerCarrerasFiltradas = async (tipo) => {
    if (!tipo) {
      setProgramasDisponibles([]);
      return [];
    }

    try {
      setLoadingProgramas(true);

      const res = await fetch(
        `${API_URL}/carreras/${tipo}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      const data = await res.json();

      const lista = Array.isArray(data)
        ? data
        : data.data || [];

      setProgramasDisponibles(lista);

      return lista;

    } catch (error) {
      console.error(
        "Error cargando carreras:",
        error
      );

      setProgramasDisponibles([]);

      return [];

    } finally {
      setLoadingProgramas(false);
    }
  };
  const limpiarModal = () => {
    setInscripciones([]);
    setInscripcionSeleccionada("");
    setInscripcion(null);

    setTipoPrograma("");
    setTipoCarrera("");
    setInstituto("");
    setDuracion("");

    setProgramasDisponibles([]);
    setSemestres([]);
    setGestiones([]);
    setGrupos([]);

    setCarreraId("");
    setCapacitacionId("");
    setSemestreId("");
    setGestionId("");
    setGrupo("");

    setEstado("");

    setLoading(false);
    setLoadingProgramas(false);
    setLoadingSemestres(false);
    setLoadingGrupos(false);
    };

  const obtenerCapacitacionesFiltradas = async (
    inst,
    dur
  ) => {
    if (!inst || !dur) {
      setProgramasDisponibles([]);
      return [];
    }

    try {
      setLoadingProgramas(true);

      const institutoLimpio =
        encodeURIComponent(inst);

      const duracionNumero =
        String(dur).match(/\d+/)?.[0] || "";

      const duracionLimpia =
        encodeURIComponent(duracionNumero);

      const res = await fetch(
        `${API_URL}/capacitacion/${institutoLimpio}/${duracionLimpia}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );


      if (!res.ok) {
        throw new Error(
          `Error en el servidor: ${res.status}`
        );
      }

      const data = await res.json();

      const lista =
        data.data && Array.isArray(data.data)
          ? data.data
          : [];

      setProgramasDisponibles(lista);

      return lista;

    } catch (error) {
      console.error(
        "Error cargando capacitaciones:",
        error
      );

      setProgramasDisponibles([]);

      return [];

    } finally {
      setLoadingProgramas(false);
    }
  };

  const fetchSemestres = async (
    tipo,
    id
  ) => {
    if (!tipo || !id) {
      setSemestres([]);
      return [];
    }

    try {
      setLoadingSemestres(true);

      const res = await fetch(
        `${API_URL}/semestre/${tipo}/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      const data = await res.json();

      const lista =
        Array.isArray(data.data)
          ? data.data
          : data;

      setSemestres(lista || []);

      return lista || [];

    } catch (error) {
      console.error(
        "Error cargando semestres:",
        error
      );

      setSemestres([]);

      return [];

    } finally {
      setLoadingSemestres(false);
    }
  };

  const fetchGrupos = async (
    semestre,
    gestion
  ) => {
    if (!semestre || !gestion) {
      setGrupos([]);
      return [];
    }

    try {
      setLoadingGrupos(true);

      const res = await fetch(
        `${API_URL}/grupos/semestres?semestre_id=${semestre}&gestion=${gestion}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      const data = await res.json();

      const lista =
        Array.isArray(data.data)
          ? data.data
          : data;


      setGrupos(lista || []);

      return lista || [];

    } catch (error) {
      console.error(
        "Error cargando grupos:",
        error
      );

      setGrupos([]);

      return [];

    } finally {
      setLoadingGrupos(false);
    }
  };

  const handleSeleccionarInscripcion = async (e) => {
    const id = e.target.value;

    setInscripcionSeleccionada(id);

    if (!id) {
      setInscripcion(null);

      setTipoPrograma("");
      setTipoCarrera("");

      setInstituto("");
      setDuracion("");

      setProgramasDisponibles([]);
      setSemestres([]);
      setGrupos([]);

      setCarreraId("");
      setCapacitacionId("");
      setSemestreId("");
      setGestionId("");
      setGrupo("");
      setEstado("");

      return;
    }

    const seleccionada =
      inscripciones.find(
        (i) =>
          String(i.id) === String(id)
      );

    if (!seleccionada) return;

    setInscripcion(seleccionada);

    const tipo =
      seleccionada.tipo_programa || "";

    const tipoReal =
      tipo === "convalidacion"
        ? "carrera"
        : tipo;

    setTipoPrograma(tipo);

    setTipoCarrera(
      seleccionada.tipo_carrera || ""
    );

    setInstituto(
      seleccionada.instituto || ""
    );

    setDuracion(
      seleccionada.duracion
        ? String(seleccionada.duracion)
        : ""
    );

    setCarreraId(
      seleccionada.carrera_id
        ? String(seleccionada.carrera_id)
        : ""
    );

    setCapacitacionId(
      seleccionada.capacitacion_id
        ? String(
            seleccionada.capacitacion_id
          )
        : ""
    );

    setSemestreId(
      seleccionada.semestre_id
        ? String(
            seleccionada.semestre_id
          )
        : ""
    );

    setGestionId(
      seleccionada.gestion_id
        ? String(
            seleccionada.gestion_id
          )
        : ""
    );

    setGrupo(
      seleccionada.grupo_id
        ? String(
            seleccionada.grupo_id
          )
        : ""
    );

    setEstado(
      seleccionada.estado || ""
    );

    if (
      tipo === "carrera" ||
      tipo === "convalidacion"
    ) {
      if (seleccionada.tipo_carrera) {
        await obtenerCarrerasFiltradas(
          seleccionada.tipo_carrera
        );
      }
    }

    if (
      tipo === "capacitacion"
    ) {
      if (
        seleccionada.instituto &&
        seleccionada.duracion
      ) {
        await obtenerCapacitacionesFiltradas(
          seleccionada.instituto,
          seleccionada.duracion
        );
      }
    }

    if (
      tipoReal &&
      (seleccionada.carrera_id ||
        seleccionada.capacitacion_id)
    ) {
      const programaId =
        tipoReal === "carrera"
          ? seleccionada.carrera_id
          : seleccionada.capacitacion_id;

      await fetchSemestres(
        tipoReal,
        programaId
      );
    }

    if (
      seleccionada.semestre_id &&
      seleccionada.gestion_id
    ) {
      await fetchGrupos(
        seleccionada.semestre_id,
        seleccionada.gestion_id
      );
    }
  };

  const handleTipoPrograma = async (e) => {
    const valor = e.target.value;

    setTipoPrograma(valor);

    setTipoCarrera("");
    setInstituto("");
    setDuracion("");

    setProgramasDisponibles([]);
    setSemestres([]);
    setGrupos([]);

    setCarreraId("");
    setCapacitacionId("");
    setSemestreId("");
    setGestionId("");
    setGrupo("");

    if (
      valor === "carrera" ||
      valor === "convalidacion"
    ) {
      /*
       * Las carreras dependen de
       * anual/semestral, por lo tanto
       * esperamos al tipo de carrera.
       */
      return;
    }

    if (valor === "capacitacion") {
      return;
    }
  };


  const handleTipoCarrera = async (e) => {
    const valor = e.target.value;

    setTipoCarrera(valor);

    setCarreraId("");
    setSemestreId("");
    setGrupo("");

    setSemestres([]);
    setGrupos([]);

    if (valor) {
      await obtenerCarrerasFiltradas(
        valor
      );
    }
  };

  const handleInstituto = (e) => {
    const valor = e.target.value;

    setInstituto(valor);

    setDuracion("");
    setProgramasDisponibles([]);

    setCapacitacionId("");
    setSemestreId("");
    setGrupo("");

    setSemestres([]);
    setGrupos([]);
  };

  const handleDuracion = async (e) => {
    const valor = e.target.value;

    setDuracion(valor);

    setCapacitacionId("");
    setSemestreId("");
    setGrupo("");

    setSemestres([]);
    setGrupos([]);

    if (instituto && valor) {
      await obtenerCapacitacionesFiltradas(
        instituto,
        valor
      );
    }
  };

  const handlePrograma = async (e) => {
    const id = e.target.value;

    setGrupo("");
    setSemestreId("");
    setSemestres([]);
    setGrupos([]);

    if (
      tipoPrograma === "carrera" ||
      tipoPrograma === "convalidacion"
    ) {
      setCarreraId(id);

      if (id) {
        const tipoReal =
          tipoPrograma === "convalidacion"
            ? "carrera"
            : tipoPrograma;

        await fetchSemestres(
          tipoReal,
          id
        );
      }

      return;
    }

    if (
      tipoPrograma === "capacitacion"
    ) {
      setCapacitacionId(id);

      if (id) {
        await fetchSemestres(
          "capacitacion",
          id
        );
      }
    }
  };

  const handleSemestre = async (e) => {
    const valor = e.target.value;

    setSemestreId(valor);
    setGrupo("");
    setGrupos([]);

    if (valor && gestionId) {
      await fetchGrupos(
        valor,
        gestionId
      );
    }
  };

  const handleGestion = async (e) => {
    const valor = e.target.value;

    setGestionId(valor);
    setGrupo("");
    setGrupos([]);

    if (valor && semestreId) {
      await fetchGrupos(
        semestreId,
        valor
      );
    }
  };


  return (
    <Dialog
        open={open}
        onClose={() => {
            limpiarModal();
            onClose();
        }}
        fullWidth
        maxWidth="md"
    >

        <DialogTitle>
            Actualizar inscripción
        </DialogTitle>

        <DialogContent>

            <Box sx={{ mt: 1 }}>


            {loading ? (
                <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    py: 3,
                }}
                >
                <CircularProgress />
                </Box>
            ) : (
                <TextField
                select
                fullWidth
                label="Inscripción"
                value={
                    String(
                    inscripcionSeleccionada || ""
                    )
                }
                onChange={
                    handleSeleccionarInscripcion
                }
                SelectProps={{
                    native: true,
                }}
                sx={{ mb: 3 }}
                >
                <option value=""></option>

                {inscripciones.map((i) => (
                    <option
                    key={`${i.tipo_programa}-${i.id}`}
                    value={String(i.id)}
                    >
                    {`${i.programa} | ${
                        i.tipo_inscripcion
                    } | Gestión ${
                        i.gestion
                    } | ${
                        i.semestre ||
                        "Sin semestre"
                    } | Grupo ${
                        i.grupo ||
                        "Sin grupo"
                    }`}
                    </option>
                ))}
                </TextField>
            )}


            {inscripcion && (
                <>
                    <Typography
                        variant="h6"
                        fontWeight="bold"
                        mb={2}
                    >
                        Datos de la inscripción
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                            <TextField
                                select
                                fullWidth
                                label="Tipo de programa"
                                value={tipoPrograma}
                                onChange={
                                handleTipoPrograma
                                }
                                SelectProps={{
                                native: true,
                                }}
                            >
                                <option value=""></option>
                                <option value="carrera">Carrera</option>
                                <option value="capacitacion">Capacitación</option>
                                <option value="convalidacion">Convalidación</option>
                            </TextField>
                        </Grid>


                        {(tipoPrograma === "carrera" ||
                        tipoPrograma === "convalidacion") && (
                            <Grid item xs={12} md={4}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Tipo de carrera"
                                    value={tipoCarrera}
                                    onChange={handleTipoCarrera}
                                    SelectProps={{native: true,}}
                                >
                                    <option value=""></option>
                                    <option value="anual">Anual</option>
                                    <option value="semestral">Semestral</option>
                                </TextField>
                            </Grid>
                        )}

                        {tipoPrograma === "capacitacion" && (
                            <Grid item xs={12} md={4}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Instituto"
                                    value={instituto}
                                    onChange={handleInstituto}
                                    SelectProps={{native: true,}}
                                >
                                    <option value=""></option>

                                    <option value="INFOPRO">INFOPRO</option>

                                    <option value="CLADECORP">CLADECORP</option>
                                </TextField>
                            </Grid>
                        )}

                        {tipoPrograma ===
                        "capacitacion" &&
                        (instituto === "INFOPRO" ||
                            instituto ===
                            "CLADECORP") && (
                        <Grid item xs={12} md={4}>
                            <TextField
                                select
                                fullWidth
                                label="Duración"
                                value={duracion}
                                onChange={
                                    handleDuracion
                                }
                                SelectProps={{
                                    native: true,
                                }}
                            >
                                <option value=""></option>
                                {instituto ===
                                    "INFOPRO" && (
                                    <>
                                        <option value="3"> 3 meses </option>
                                        <option value="7">7 meses</option>
                                    </>
                                )}
                                {instituto ===
                                    "CLADECORP" && (
                                    <>
                                        <option value="1">1 mes</option>

                                        <option value="3">3 meses</option>

                                        <option value="7">7 meses</option>
                                    </>
                                )}
                            </TextField>
                        </Grid>
                        )}


                        <Grid item xs={12} md={4}>
                            <TextField
                                select
                                fullWidth
                                label={
                                    tipoPrograma ===
                                        "carrera" ||
                                    tipoPrograma ===
                                        "convalidacion"
                                        ? "Seleccionar carrera"
                                        : "Seleccionar curso"
                                }
                                value={
                                    tipoPrograma ===
                                        "carrera" ||
                                    tipoPrograma ===
                                        "convalidacion"
                                        ? carreraId
                                        : capacitacionId
                                }
                                onChange={handlePrograma}
                                SelectProps={{native: true,}}
                                disabled={loadingProgramas}
                            >
                                <option value=""></option>

                                {programasDisponibles.map(
                                (prog) => (
                                    <option key={prog.id} value={prog.id}>
                                        {prog.nombre}
                                    </option>
                                )
                                )}
                            </TextField>

                            {loadingProgramas && (
                                <CircularProgress
                                size={20}
                                sx={{ mt: 1 }}
                                />
                            )}
                        </Grid>

                        {tipoPrograma !==
                        "capacitacion" && (
                        <Grid item xs={12} md={4}>
                            <TextField
                                select
                                fullWidth
                                label="Semestre/Año/Módulo"
                                value={semestreId}
                                onChange={handleSemestre}
                                SelectProps={{native: true,}}
                                disabled={loadingSemestres}
                            >
                            <option value=""></option>
                            {semestres.map(
                                (s) => (
                                    <option key={s.id} value={s.id}>
                                        {s.nombre}{" "}{s.numero}
                                    </option>
                                )
                            )}
                            </TextField>

                            {loadingSemestres && (
                                <CircularProgress
                                    size={20}
                                    sx={{ mt: 1 }}
                                />
                            )}
                        </Grid>
                        )}


                        <Grid item xs={12} md={4}>
                            <TextField
                                select
                                fullWidth
                                label="Gestión"
                                value={gestionId}
                                onChange={
                                handleGestion
                                }
                                SelectProps={{
                                native: true,
                                }}
                            >
                                <option value=""></option>

                                {gestiones.map(
                                    (g) => (
                                        <option key={g.id} value={g.id}>
                                            {g.nombre}
                                        </option>
                                    )
                                )}
                            </TextField>
                        </Grid>


                        <Grid item xs={12} md={4}>

                        {loadingGrupos ? (
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    height: "56px",
                                }}
                            >
                                <CircularProgress
                                    size={24}
                                />
                            </Box>
                        ) : (
                            <TextField
                                select
                                fullWidth
                                label="Grupo"
                                value={grupo}
                                onChange={(e) =>
                                    setGrupo(
                                    e.target.value
                                    )
                                }
                                SelectProps={{
                                    native: true,
                                }}
                            >
                            <option value=""></option>

                            {grupos.length > 0 ? (
                                grupos.map(
                                (g) => {
                                    const grupoLleno =
                                    Number(
                                        g.cupo_maximo
                                    ) === 0;

                                    return (
                                    <option key={g.id} value={g.id}disabled={grupoLleno}>
                                        {g.nombre} (
                                        {g.turno},{" "}
                                        {g.dias})
                                        {grupoLleno
                                        ? " (GRUPO LLENO)"
                                        : ""}
                                    </option>
                                    );
                                }
                                )
                            ) : (
                                <option value=""disabled>No hay grupos disponibles</option>
                            )}
                            </TextField>
                        )}

                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TextField
                                select
                                fullWidth
                                label="Estado"
                                value={estado}
                                onChange={(e) =>
                                setEstado(
                                    e.target.value
                                )
                                }
                                SelectProps={{
                                native: true,
                                }}
                            >
                                <option value=""></option>
                                <option value="por_iniciar">Por iniciar</option>
                                <option value="activo"> Activo</option>
                                <option value="inactivo">Inactivo</option>
                                <option value="abandonado">Abandonado</option>
                                <option value="finalizado">Finalizado</option>
                            </TextField>
                        </Grid>

                    </Grid>
                </>
            )}
            </Box>
        </DialogContent>

        <DialogActions>
            <Button
                onClick={() => {
                    limpiarModal();
                    onClose();
                }}
                >
                Cancelar
            </Button>
            <Button
                variant="contained"
                disabled={!inscripcion || loading}
                onClick={guardarInscripcion}
            >
                {loading ? (
                    <CircularProgress
                        size={24}
                        sx={{ color: "white" }}
                    />
                ) : (
                    "Guardar"
                )}
            </Button>
        </DialogActions>

    </Dialog>
  );
};

export default ActualizarGruposEstado;